import { render, staticRenderFns } from "./XT.vue?vue&type=template&id=2247834e&scoped=true&"
import script from "./XT.vue?vue&type=script&lang=js&"
export * from "./XT.vue?vue&type=script&lang=js&"
import style0 from "./XT.vue?vue&type=style&index=0&id=2247834e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2247834e",
  null
  
)

component.options.__file = "XT.vue"
export default component.exports